import {useCallback, useMemo, useRef} from 'react';
import {getNewValueIds} from '../functions/getNewValueIds';

export const useGetValueId = (values: unknown[]) => {
  const previousValuesIdsRef = useRef<Array<{id: string; value: unknown}>>([]);
  const idsCounterRef = useRef(0);

  const valueIds = useMemo(() => {
    const newValuesIds = getNewValueIds(
      previousValuesIdsRef.current,
      values,
      () => (idsCounterRef.current++).toString(),
    );

    previousValuesIdsRef.current = newValuesIds;

    return newValuesIds;
  }, [values]);

  return useCallback(
    (valueIndex: number): string => {
      return valueIds[valueIndex]?.id ?? (idsCounterRef.current++).toString();
    },
    [valueIds],
  );
};
